import useTranslation from "@casino/legacy/client/hooks/i18n/useTranslation";
import useLoginError from "@casino/legacy/client/hooks/user/useLoginError";
import useToast from "@casino/legacy/client/hooks/useToast";
import type { DeepMap, DeepPartial, FieldError } from "react-hook-form";
import type FormValues from "../FormValues";

const useSms2fa = (
  errors: DeepMap<DeepPartial<FormValues>, FieldError>,
  submit: (values: FormValues) => void,
  formValues: FormValues,
) => {
  const { showToast } = useToast();
  const { error: loginError } = useLoginError();

  const loginErrorMessage =
    loginError && loginError !== "SMS_2FA_IS_REQUIRED"
      ? `error.${loginError}`
      : "";

  const errorMessage =
    errors?.otp?.message && errors?.otp?.message !== "error.SMS_2FA_IS_REQUIRED"
      ? errors.otp.message
      : "";

  const authCodeErrorMessage = useTranslation(
    errorMessage || loginErrorMessage,
  );

  const handleResendCodeClick = () => {
    submit(formValues);
    showToast({
      message: "profile.new_code_sent",
      timeout: 6000,
      variant: "success",
      position: "bottom",
    });
  };

  return { authCodeErrorMessage, handleResendCodeClick };
};

export default useSms2fa;
